import React from 'react';
import { useForm } from 'react-hook-form';

import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../MultipartForm/stateMachineActions';

import FormStepWrapper from './FormStepWrapper';
import { MPFStepProps, StudentData } from '../../util/types';
import TextInput from '../MultipartForm/Fields/TextInput';
import Select from '../MultipartForm/Fields/Select';

import stringsToOptions from '../../util/stringsToSelectOptions';

// TODO: put 90% of this into a super class or interface or something
const Step2 = (props: MPFStepProps) => {
  const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm();
  const { actions, state } = useStateMachine({ updateAction });
  const onSubmit = (data: any) => {
    // data.step = 1;
    actions.updateAction({
      formData: data,
    });
    props.next();
    // props.history.push('./step2');
  };
  const onBack = (e: React.MouseEvent) => {
    e.preventDefault();
    props.prev();
  };

  const content = (
    <>
      <h3 className="Form__heading">Project supporter:</h3>
      <p className="Form__subheading">
        Please provide information for a project advisor (such as a parent/guardian) who will support you and receive the grant on your behalf, if you are under 18. If you are over 18, you may enter your own information.
      </p>
      <fieldset className="Fieldset Fieldset--two-col">
        <TextInput
          name="supporterFirstName"
          label="First name"
          validationObj={{required: 'This field is required'}}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          errors={errors}
          returnToStep={props.returnToStep}
        />
        <TextInput
          name="supporterLastName"
          label="Last name"
          validationObj={{required: 'This field is required'}}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          errors={errors}
          returnToStep={props.returnToStep}
        />
        <Select
          name="supporterRelationship"
          label="Relationship to you"
          // defaultValue={props.studentData.grade}
          validationObj={{required: 'This field is required'}}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          setValue={setValue}
          errors={errors}
          returnToStep={props.returnToStep}
          // I need to map 'Other' to undefined in the backend anyways, but it's required here
          // { label: 'Parent/Guardian', value: 'Parent/Guardian' },
          // { label: 'Educator', value: 'Employee' },
          // { label: 'Other', value: 'None' },
          // Parent/Guardian, Employee (educators), or None (Other)
          options={stringsToOptions(
            ['Parent/Guardian','Educator','Other']
          )}
        />
        <TextInput
          name="supporterPhone"
          label="Phone number"
          type="tel"
          // defaultValue={props.studentData.phone}
          validationObj={{required: 'This field is required'}}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          errors={errors}
          returnToStep={props.returnToStep}
        />
        <TextInput
          name={`supporterEmail`}
          label="Email address"
          type="email"
          disclaimer={
            <p className="TextInput__disclaimer">
              <span>
                Please provide an email address that is different from the one you used in Step 1.
              </span>
            </p>
          }
          // defaultValue={props.studentData.email}
          validationObj={{
            required: 'This field is required',
            validate: (value: string) => {
              const emails = state?.students?.map((student: StudentData) => student.email);
              if (emails?.includes(value)) return 'This email address is already in use';
              return true;
            }
          }}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          errors={errors}
          returnToStep={props.returnToStep}
        />
        <TextInput
          name={`supporterConfirmEmail`}
          label="Confirm email address"
          type="email"
          // defaultValue={props.studentData.email}
          validationObj={{ validate: {
            emailEqual: (value: string) => (value === getValues()[`supporterEmail`]) || 'Email confirmation error!',
          }}}
          formData={state.formData}
          showEditBtn={props.reviewMode ? true : false}
          editable={props.reviewMode ? false : true}
          register={register}
          errors={errors}
          returnToStep={props.returnToStep}
        />
      </fieldset>


      { props.reviewMode ? undefined :
      <div className="bottom-buttons">
        <button onClick={onBack} className="btn btn--back">Back</button>
        <input type='submit' value="Next" />
      </div>
      }
    </>
  );

  // Wrap in form if not in review mode
  return (
    props.reviewMode
    ? content
    : <FormStepWrapper onSubmit={handleSubmit(onSubmit)} content={content} />
  );
};

export default Step2;
